<div class="date-container"><span *ngIf="shouldDisplay" class="date">{{date}}</span></div>